import functions from "./functions.js";

$(function() {

    const $form = $('.form-booking');
    const form = $form[0];

    if ( !form ) {
        return;
    }

    console.log(form);

    const booking = {
        $form: null,
        $calculation: null,
        calc: [],
        persons: null,

        init() {
            booking.$form = $(".form-booking");
            booking.$calculation = $(".table-calculation");
            booking.params = JSON.parse(booking.$form.attr('data-params'));

            booking.$calculation.find("*[data-calc]").each(function( index ) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function(e) {
                let $row = $(this).closest('tr');
                let $quantity = $row.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && ! value) {
                    $quantity.prop('value', 1);
                } else if ( ! checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            booking.$calculation.find('select.quantity').change(function(e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && ! $checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if ( ! value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();

            booking.$form.on('submit', e => {
                booking.submit();
            });

        },
        submit() {

            /*
            let optionals = [];
            $.each(booking.calc, function( key, calc ) {
                if (calc.isOptional && calc.inCalc) {
                    optionals.push(calc.itemDefinitionId.categoryId.key)
                }
            });
            booking.params.optionals = optionals;
            */

            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999-1000000)+1) + 1000000);

            $.each(booking.params, function( key, param ) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });
        },
        calculate($elem) {
            let $row = $elem.closest('tr');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }


            $.each(booking.calc, function( key, calc ) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                }
            });

            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray( item.paymentTypeId.key, ['perPerson','perPersonPerDay','perPersonPerWeek'] ) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        total() {
            let total = 0.00;

            $.each(booking.calc, function( key, calc ) {
                if ( ! calc.onSpot && calc.inCalc) {
                    total += booking.itemTotal(calc);
                }
            });

            booking.$calculation.find('.total-amount').html(functions.formatMoney(total, 2, ',', '.'));
        }
    }

    booking.init();
});